var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_fix"},[_c('a',{staticClass:"my_btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$store.commit('changeModal', true)}}},[_vm._v("\n    予約する\n    "),_c('i',{staticClass:"fas fa-chevron-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }